import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FORM_DEPARTMENT_TEACHERS_LABEL } from '../../constants/translationLabels/formElements';
import { RHFAutocomplete } from '../../share/rhf';

const DepartmentsList = ({ control, setValue }) => {
    const { t } = useTranslation('common');
    const departments = useSelector((state) => state.departments.departments);

    return (
        <RHFAutocomplete
            control={control}
            name="department"
            options={departments || []}
            label={t(FORM_DEPARTMENT_TEACHERS_LABEL)}
            getOptionLabel={(department) => (department ? department.name : '')}
            className="schedule-form_department"
            onAfterChange={(value) => {
                if (value) {
                    setValue('group', null);
                    setValue('teacher', null);
                }
            }}
        />
    );
};

export default DepartmentsList;
